
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { FsBadgeModule } from '@firestitch/badge';
import { FsDialogModule } from '@firestitch/dialog';
import {
  FilterConfig,
  FsFilterModule,
  ItemType,
} from '@firestitch/filter';

import { map } from 'rxjs/operators';

import { EnvironmentData } from '@common/data';
import { Environment } from '@common/interfaces';
import { SessionService } from '@common/services';

import { SidenavService } from '@libs/layouts/side-nav/services';


@Component({
  templateUrl: './environment-switch.component.html',
  styleUrls: ['./environment-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogModule,
    MatButtonModule,
    FsDialogModule,
    FsFilterModule,
    FsBadgeModule,
  ],
})
export class EnvironmentSwitchComponent implements OnInit {
  
  public data = inject(MAT_DIALOG_DATA);
  public environments: Environment[] = [];
  public projectLimit = 5;
  public filterConfig: FilterConfig;

  private _dialogRef = inject<MatDialogRef<EnvironmentSwitchComponent>>(MatDialogRef);
  private _environmentData = inject(EnvironmentData);
  private _sessionService = inject(SessionService);
  private _router = inject(Router);
  private _sidenavService = inject(SidenavService);
  private _cdRef = inject(ChangeDetectorRef);

  public ngOnInit(): void {
    this._initConfig();
  }

  public switch(environment: Environment): void {
    this._environmentData
      .switch(this._sessionService.accountId(), environment.id)
      .subscribe((environment_) => {
        this._sidenavService.hideMobile();
        this._sessionService.environment(environment_);
        this._dialogRef.close(environment_);
        this._router.navigate(['blank'])
          .then(() => {
            this._router.navigateByUrl('/home');
          });
      });
  }

  public close(): void {
    this._dialogRef.close();
  }

  private _initConfig(): void {
    this.filterConfig = {
      items: [
        {
          name: 'keyword',
          type: ItemType.Keyword,
          label: 'Search',
          fullWidth: true,
        },
      ],
      queryParam: false,
      autofocus: true,
      load: false,
      init: (query) => {
        this._fetchEnvironments(query);
      },
      clear: () => {
        this._fetchEnvironments();
      },
      change: ((query) => {
        this._fetchEnvironments(query);
      }),
    };
  }

  private _fetchEnvironments(query?): void {
    this._environmentData
      .gets({
        ...query,
        avatars: true,
        projects: true,
        projectAvatars: true,
      })
      .pipe(
        map((environments) => {
          return environments
            .map((environment) => {
              if (environment.projects.length > this.projectLimit) {
                environment.projects = environment.projects.slice(0, this.projectLimit);
              }

              return environment;
            });
        }),
      )
      .subscribe((response) => {
        this.environments = response;
        this._cdRef.markForCheck();
      });
  }

}
